export const buildPropertyUpdateParams = (
  formData: any,
  userId: string,
  imageUrl: string | null
): any => {
  const stages: any[] =
    formData.constructionStages && formData.constructionStages.length > 0
      ? formData.constructionStages.filter((cs: any) => !cs.new)
      : [];

  return {
    id: formData.propertyId,
    propertyId: formData.propertyId,
    name: formData.name,
    addressLine1: formData.addressLine1,
    addressLine2: '',
    city: formData.city,
    province: formData.province,
    postalCode: formData.postalCode,
    latitude: '17.5896',
    longitude: '17.556896',
    image: imageUrl != null ? imageUrl : formData.image,
    UserId: userId,
    PropertyManagerId: formData.propertyManager?.id
      ? formData.propertyManager.id
      : formData.propertyManagerId,
    StrataManagerId: formData.strataManagerId
      ? formData.strataManagerId
      : formData.strataManager?.id
        ? formData.strataManager.id
        : null,
    ConstructionStages: stages,
    modulePermissions: formData.modulePermissions || [],
  };
};